import { Flex, Grid, Show, Tag, Text, Tooltip } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import React from "react";
import { useAccount } from "wagmi";

type VaultPointProps = {
  data: {
    walletConnect: string;
    supported: {
      logo: string;
      title: string;
      tag: string;
      key: string;
      value?: string;
      isComingSoon?: boolean;
      comingSoonCTA?: string;
      infoCTA?: {
        label: string;
        icon: string;
        tooltipText: string;
      };
    }[];
  };
};

const VaultPoints = ({ data }: VaultPointProps) => {
  const { isConnected } = useAccount();

  return (
    <Flex p={{ base: "10px", md: "20px" }} direction={"column"}>
      {!isConnected && (
        <Text fontSize="12px" lineHeight="14.4px" fontWeight="400" mb="30px">
          {data.walletConnect}
        </Text>
      )}

      <Grid
        gridTemplateColumns={{ base: "1fr 1fr", md: "1fr 1fr" }}
        gap={{ base: "16px", md: "20px" }}
      >
        {data.supported.map((item) => (
          <Flex gap="0.5rem" alignItems="flex-start" key={item.key}>
            <Show below="md">
              <BaseImage
                src={item.logo}
                width="20"
                height="20"
                alt={`${item.title} logo`}
              />
            </Show>

            <Flex direction="column" gap="6px">
              <Flex
                direction={{ base: "column", md: "row" }}
                gap="6px"
                alignItems={{ base: "flex-start", md: "center" }}
              >
                <Show above="md">
                  <BaseImage
                    src={item.logo}
                    width="18"
                    height="18"
                    alt={`${item.title} logo`}
                  />
                </Show>
                <Text
                  fontSize="14px"
                  lineHeight="16.4px"
                  fontWeight="600"
                  style={{ textWrap: "nowrap" }}
                >
                  {item.title}
                </Text>
                <Tag
                  size={"sm"}
                  width="max-content"
                  bgColor="#B6DFDF"
                  fontSize="10px"
                  lineHeight="10px"
                  fontWeight="600"
                  py="0"
                >
                  {item.tag}
                </Tag>
              </Flex>

              {isConnected && !item?.isComingSoon && !item.infoCTA && (
                <Text
                  fontSize={{ base: "14px", md: "20px" }}
                  fontWeight="600"
                  lineHeight={"20px"}
                  letterSpacing={"-1%"}
                  color={"textPrimary"}
                >
                  {item.value || 0}
                </Text>
              )}
              {isConnected && item?.isComingSoon && (
                <Text
                  color="textPrimary"
                  pl={1}
                  fontWeight="500"
                  fontSize={{ base: "10px", md: "12px" }}
                >
                  {item?.comingSoonCTA || "Coming Soon"}
                </Text>
              )}
              {isConnected && item.infoCTA && (
                <Tooltip
                  label={
                    <Text fontSize={"12px"} fontWeight={300} maxW={"245px"}>
                      {item.infoCTA.tooltipText}
                    </Text>
                  }
                  hasArrow
                  color="textSecondary"
                  fontSize="12px"
                  bg="backgroundCard"
                  p="8px"
                  borderRadius="8px"
                  placement="top"
                >
                  <Flex
                    alignItems={"center"}
                    gap="2px"
                    borderBottom="1px dotted #075A5A"
                    width="fit-content"
                  >
                    <BaseImage
                      src={item.infoCTA.icon}
                      alt={item.key}
                      width={"14"}
                      height={"14"}
                    />
                    <Text
                      color="textPrimary"
                      fontWeight="500"
                      fontSize={{ base: "10px", md: "12px" }}
                    >
                      {item.infoCTA.label}
                    </Text>
                  </Flex>
                </Tooltip>
              )}
            </Flex>
          </Flex>
        ))}
      </Grid>
    </Flex>
  );
};

export default VaultPoints;
